// ----------------------------------------------------------------------

export function container(theme) {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          // Override MUI's built-in maxWidth constraints
          '&.MuiContainer-maxWidthXs': {
            maxWidth: 'none !important',
          },
          '&.MuiContainer-maxWidthSm': {
            maxWidth: 'none !important',
          },
          '&.MuiContainer-maxWidthMd': {
            maxWidth: 'none !important',
          },
          '&.MuiContainer-maxWidthLg': {
            maxWidth: 'none !important',
          },
          '&.MuiContainer-maxWidthXl': {
            maxWidth: 'none !important',
          },
          // Force full width when themeStretch is enabled
          '&[data-stretch="true"]': {
            maxWidth: 'none !important',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
          },
        },
      },
    },
  };
} 